export default function WhatIncluded() {
  const features = [
    {
      icon: 'ri-smartphone-line',
      title: '一頁式網站',
      description: 'RWD手機/電腦'
    },
    {
      icon: 'ri-building-line',
      title: '品牌/公司簡介',
      description: '完整呈現您的品牌形象'
    },
    {
      icon: 'ri-star-line',
      title: '服務或產品重點',
      description: '最多3點'
    },
    {
      icon: 'ri-phone-line',
      title: '一個行動按鈕',
      description: '聯絡方式/留言/LINE'
    },
    {
      icon: 'ri-cloud-line',
      title: '我方代管與基本設置',
      description: '專業維運服務'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            0元一頁式網站包含什麼？
          </h2>
          <p className="text-lg text-gray-600">固定結構，非客製</p>
          <div className="w-20 h-1 bg-teal-500 mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-2xl text-teal-600`}></i>
              </div>
              <div className="flex items-start mb-2">
                <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-2 mt-1"></i>
                <h3 className="text-lg font-semibold text-gray-900">{feature.title}</h3>
              </div>
              <p className="text-sm text-gray-600 ml-7">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border-2 border-teal-100">
          <div className="flex items-center justify-center mb-6">
            <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center">
              <i className="ri-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 ml-4">完成後即可對外使用</h3>
          </div>
          
          <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
            <div className="flex items-start">
              <i className="ri-information-line text-amber-600 text-xl mr-3 mt-1 flex-shrink-0"></i>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">※ 說明：</h4>
                <p className="text-sm text-gray-700 leading-relaxed">
                  網站建置服務本身為0元，<br />
                  實際對外上線所需之<strong>「網域註冊費用」</strong>與<strong>「年度代管／主機費用」</strong>，<br />
                  屬第三方必需成本，需由客戶自行負擔。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
